export default __webpack_public_path__ + "static/media/connect_logo.348fb51a.svg";